import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

// Pages
import Landing from './pages/Landing'
import Chat from './pages/Chat'
import Memory from './pages/Memory'
import Settings from './pages/Settings'

// Components
import Navbar from './components/layout/Navbar'
import Background from './components/ui/Background'

// Hooks
import { useVoiceChat } from './hooks/useVoiceChat'

const App = () => {
  const location = useLocation()
  const { stopAllVoiceActivities } = useVoiceChat()
  
  useEffect(() => {
    document.title = 'Lyo - Emotional Clarity AI'
  }, [])

  // Stop all voice activities when navigating away from chat ONLY
  useEffect(() => {
    if (location.pathname !== '/chat') {
      console.log('App: Navigated away from chat to:', location.pathname, '- stopping voice activities')
      stopAllVoiceActivities()
    }
  }, [location.pathname, stopAllVoiceActivities])

  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col">
      <Background />
      
      {location.pathname !== '/' && <Navbar />}
      
      <main className="flex-1">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Landing />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/memory" element={<Memory />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </AnimatePresence>
      </main>
    </div>
  )
}

export default App